module.exports = __webpack_public_path__ + "static/media/star.423faf81.svg";